import gql from 'graphql-tag';

const SEND_PANDADOC_FROM_OPPORTUNITY = gql`
  mutation SendPandaDocFromOpportunity(
    $campaignOrder: JSON!
    $oppName: String!
    $sfOpportunityId: String
    $name: String
    $decisionMakerFirstName: String
    $decisionMakerLastName: String
    $salesforceAccountName: String
    $proposalFilename: String
    $decisionMakerTitle: String
    $decisionMakerPhone: String
  ) {
    sendPandaDocFromOpportunity(
      campaignOrder: $campaignOrder
      oppName: $oppName
      sfOpportunityId: $sfOpportunityId
      name: $name
      decisionMakerFirstName: $decisionMakerFirstName
      decisionMakerLastName: $decisionMakerLastName
      salesforceAccountName: $salesforceAccountName
      proposalFilename: $proposalFilename
      decisionMakerTitle: $decisionMakerTitle
      decisionMakerPhone: $decisionMakerPhone
    ) {
      success
      documentId
      status
      viewUrl
      error
    }
  }
`;

export default SEND_PANDADOC_FROM_OPPORTUNITY;
